import { WORKER_CANCEL_LIVE } from '../constants';

export const cancelLive = (key, value) => ({type: WORKER_CANCEL_LIVE, payload: {key, value}});